import React, { useEffect, useState } from 'react'
import './Analytics.scss'
import axios from 'axios';
import moment from 'moment'
import { Link, useLocation } from "react-router-dom";

const Analytics = () => {

    const [games, setGames] = useState([]);
    const [win, setWins] = useState([]);
    const [loss, setLosses] = useState([]);

    // Daily
    const [daywins, setDayWins] = useState([]);
    const [daylosses, setDayLosses] = useState([]);

    // Weekly
    const [weekwins, setWeekWins] = useState([]);
    const [weeklosses, setWeekLosses] = useState([]);

    // Monthly
    const [monthwins, setMonthWins] = useState([]);
    const [monthlosses, setMonthLosses] = useState([]);

    const [error, setError] = useState(null);
    var isoDate = new Date().toISOString()

    var winNumber = Object.keys(win).length
    var lossNumber = Object.keys(loss).length
    var totalGames = Object.keys(games).length
    var winPercent = winNumber / totalGames * 100

    var winPercent2 = (winPercent.toString().substring(0, 5))

    // await axios.get(`https://admin.capncovers.com/api/games?filters[date][$lte]=${isoDate}&sort=date:DESC`)

    // Match History
    useEffect(() => {
        async function fetchGame() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&sort=date:DESC`)
                    .then(response => setGames(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchGame();

    }, [])

    // Total Wins
    useEffect(() => {
        async function fetchWins() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[status][$eq]=Win`)
                    .then(response => setWins(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchWins();

    }, [])

    // Total Losses
    useEffect(() => {
        async function fetchLosses() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[status][$eq]=Loss`)
                    .then(response => setLosses(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchLosses();

    }, [])

    // 24 Hours
    var yesterday = new Date(Date.now() - 86400 * 1000).toISOString()

    useEffect(() => {
        async function fetchDayWins() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${yesterday}&filters[status][$eq]=Win`)
                    .then(response => setDayWins(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchDayWins();

    }, [])

    useEffect(() => {
        async function fetchDayLosses() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${yesterday}&filters[status][$eq]=Loss`)
                    .then(response => setDayLosses(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchDayLosses();

    }, [])

    const dayWinsNegative = daywins
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const dayWins = dayWinsNegative * -1

    const dayLosses = daylosses
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const dailyUnits = dayWins - dayLosses

    // Last Week
    var lastWeek = new Date(Date.now() - 604800 * 1000).toISOString()

    useEffect(() => {
        async function fetchWeekWins() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${lastWeek}&filters[status][$eq]=Win`)
                    .then(response => setWeekWins(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchWeekWins();

    }, [])

    useEffect(() => {
        async function fetchWeekLosses() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${lastWeek}&filters[status][$eq]=Loss`)
                    .then(response => setWeekLosses(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchWeekLosses();

    }, [])

    const weekWinsNegative = weekwins
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const weekWins = weekWinsNegative * -1

    const weekLosses = weeklosses
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const weeklyUnits = weekWins - weekLosses

    // Last Month
    /* var lastMonth = new Date(Date.now() - 2628288 * 1000).toISOString()

    useEffect(() => {
        async function fetchMonthWins() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${lastMonth}&filters[status][$eq]=Win`)
                    .then(response => setMonthWins(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchMonthWins();

    }, [])

    useEffect(() => {
        async function fetchMonthLosses() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[status][$ne]=null&filters[date][$lte]=${isoDate}&filters[date][$gte]=${lastMonth}&filters[status][$eq]=Loss`)
                    .then(response => setMonthLosses(response.data.data));

            } catch (error) {
                setError(error)
            }
        }
        fetchMonthLosses();

    }, [])

    const monthWinsNegative = monthwins
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const monthWins = monthWinsNegative * -1

    const monthlyLosses = monthlosses
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const monthlyUnits = monthWins - monthlyLosses */


    // Total Units
    const lossSum = loss
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const winSumNegative = win
        .map(item => item.attributes.units)
        .reduce((prev, curr) => prev - curr, 0);

    const winSum = winSumNegative * -1

    const totalUnits = winSum - lossSum

    // console.log(loss)
    // console.log(Object.keys(games).length)
    // console.log('Number of Wins: ' + Object.keys(wins).length)
    // console.log('Number of losses: ' + Object.keys(loss).length)

    // <span style={{ fontSize: 14, fontWeight: 400 }}>(Last 30 Days)</span>

    return (
        <div id='analyticspage'>
            <h1>Analytics <span style={{ fontSize: 13, fontWeight: 400, marginLeft: 2 }}> {winPercent2}% win rate</span></h1>
            <div className='analyticsGrid'>
                <div className='analyticCard'>
                    <h2>Win/Loss</h2>
                    <h3>{winNumber}W/{lossNumber}L</h3>
                </div>
                <div className='analyticCard'>
                    <h2>Daily Units</h2>
                    <h3>{dailyUnits}</h3>
                </div>
                <div className='analyticCard'>
                    <h2>Weekly Units</h2>
                    <h3>{weeklyUnits}</h3>
                </div>
                <div className='analyticCard'>
                    <h2>Total Units</h2>
                    <h3>{totalUnits}</h3>
                </div>
            </div>
            <div className='gameHistory'>
                <h1>Previous Picks<span style={{ fontSize: 13, fontWeight: 400, marginLeft: 2 }}> Past {totalGames} games</span></h1>
                <div className='gameTableBold'>
                    <p>Date</p>
                    <p>Game</p>
                    <p>Pick</p>
                    <p>Units</p>
                    <p>Result</p>
                </div>
                {games.map((item) => (
                    <div className='gameTable' key={item.id}>
                        <p>
                            {
                                moment(item.attributes.date).format("MM/DD/YYYY")
                            }
                        </p>
                        <p className='gameName'>{item.attributes.title}</p>
                        <p>{item.attributes.pick}</p>
                        <p className='hideMobile'>{item.attributes.units}</p>
                        <p className={item.attributes.status == 'Win' ? 'win status' : 'status'}>{item.attributes.status}</p>
                    </div>
                ))}
            </div>
            {/* <div className='joinMessage'>
                <h1 className='joinText'>Join the winning team</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum veniam assumenda ullam nemo optio quidem dolore eos nostrum temporibus exercitationem.</p>
                <a className="btn joinButton text-nowrap" href="/#pricing">Join Us</a>
            </div> */}
        </div >
    )
}

export default Analytics